var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"lyt-teaser-grid",attrs:{"data-column-count":_vm.props.columns,"data-load":"layouts/teaser-grid"}},[_c('div',{staticClass:"lyt-teaser-grid__grid"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }